export default __webpack_public_path__ + "static/media/1.9a652ab8.png";